<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat>
					<v-card-text class="pb-0 pt-2">
						<v-row class="pb-1">
							<v-col class="d-flex justify-start pa-0 pl-2">
								<v-btn color="primary" @click="addClick">
									<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
								</v-btn>
							</v-col>
							<v-col class="d-flex justify-center pb-0 pt-0">
								<v-card-title class="text-center pa-2 pb-2 pt-0">
									{{ $t('modules.candidates') }}</v-card-title
								>
							</v-col>
							<v-col></v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0 pt-0">
								<TheTable
									:additional-filters="candidatesTable.additionalFilters"
									:default-sort="candidatesTable.defaultSort"
									:excel="true"
									:fields="candidatesTable.headers"
									:header-selection-key="'candidates-headers'"
									:height="candidatesTable.height"
									:total-records="candidatesTable.total"
									:filter-save-key="'candidates-filters'"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in candidatesTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editClick(props.item.id, true)"
									>
										<td
											v-if="candidatesTable.selectedHeaders.includes('id')"
											@click="editClick(item.id, false)"
										>
											{{ item.id }}
										</td>
										<td
											v-if="candidatesTable.selectedHeaders.includes('first_name')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.first_name }}</b>
										</td>
										<td
											v-if="candidatesTable.selectedHeaders.includes('last_name')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.last_name }}</b>
										</td>
										<td
											v-if="candidatesTable.selectedHeaders.includes('oib')"
											@click="editClick(item.id, false)"
										>
											{{ item.oib }}
										</td>
										<td
											v-if="candidatesTable.selectedHeaders.includes('date_of_birth')"
											@click="editClick(item.id, false)"
										>
											{{
												item.date_of_birth != null
													? item.date_of_birth.split('-').reverse().join('.')
													: ''
											}}
										</td>
										<td
											v-if="candidatesTable.selectedHeaders.includes('country')"
											@click="editClick(item.id, false)"
										>
											{{ item.country.name }}
										</td>
										<td
											v-if="candidatesTable.selectedHeaders.includes('partner')"
											@click="editClick(item.id, false)"
										>
											{{ item.partner ? item.partner.name : '-' }}
										</td>
										<td
											v-if="candidatesTable.selectedHeaders.includes('email')"
											@click="editClick(item.id, false)"
										>
											{{ item.email }}
										</td>
										<td
											v-if="candidatesTable.selectedHeaders.includes('loyalty_card')"
											@click="editClick(item.id, false)"
										>
											{{ item.loyalty_card }}
										</td>
										<td
											style="text-align: right"
											v-if="candidatesTable.selectedHeaders.includes('loyalty_points')"
											@click="editClick(item.id, false)"
										>
											{{ item.loyalty_consent ? item.loyalty_points : '' }}
										</td>
										<td
											v-if="candidatesTable.selectedHeaders.includes('active')"
											@click="editClick(item.id, false)"
										>
											<v-icon v-if="item.active" small>fa-check</v-icon>
										</td>
										<td>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="editClick(item.id, true)"
														v-on="on"
													>
														<v-icon small>fa-external-link-alt</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.openInNewTab') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'Candidates',
	components: { TheTable },
	data: function () {
		return {
			candidatesTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.id'), value: 'id', type: 'string', width: '60px', allowFilter: true },
					{ text: this.$t('fields.firstName'), value: 'first_name', type: 'string', allowFilter: true },
					{ text: this.$t('fields.lastName'), value: 'last_name', type: 'string', allowFilter: true },
					{ text: this.$t('fields.oib'), value: 'oib', type: 'string', allowFilter: true },
					{ text: this.$t('fields.dateOfBirth'), value: 'date_of_birth', type: '', allowFilter: true },
					{
						text: this.$t('fields.country'),
						value: 'country',
						type: 'dropdown|countries',
						allowFilter: true,
					},
					{
						text: this.$t('fields.company'),
						value: 'partner',
						type: 'dropdown|partners',
						allowFilter: true,
					},
					{ text: this.$t('fields.email'), value: 'email', type: 'string', allowFilter: true },
					{ text: this.$t('fields.loyaltyCard'), value: 'loyalty_card', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.loyaltyPoints'),
						value: 'loyalty_points',
						type: '',
						allowFilter: true,
						alignRight: true,
					},
					{
						text: this.$t('fields.active'),
						value: 'active',
						type: 'boolean',
						width: '100px',
						allowFilter: false,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [
					{ text: this.$t('fields.dateOfBirth'), value: 'date_of_birth', type: 'date_range' },
					{ text: this.$t('fields.loyaltyPoints'), value: 'loyalty_points', type: 'price_range' },
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'updated_at',
					descending: true,
				},
			},
		};
	},
	methods: {
		addClick() {
			this.$router.push('/candidates/0');
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/candidates/' + id);
			} else {
				let routeData = this.$router.resolve('/candidates/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.candidatesTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.candidatesTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'candidates',
				request,
				(data, success) => {
					if (success) {
						vm.candidatesTable.items = data.items;
						vm.candidatesTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.candidatesTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'candidates',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/candidates', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.candidatesTable.height = window.innerHeight - 243 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.candidates'), href: '/#/candidates', disabled: true },
		]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
